import React, { Component } from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import LastPlayedSongsSlider from './LastPlayedSongsSlider';
import Placeholder from '../../../common/placeholder/Placeholder';

class LastPlayedSongs extends Component {
    componentDidMount() {
        this.props.fetchLastPlayedSongsIfNeeded();
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.lastPlayedSongs !== this.props.lastPlayedSongs ||
            nextProps.time !== this.props.time ||
            nextProps.currentMetaId !== this.props.currentMetaId;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentMetaId !== this.props.currentMetaId) {
            // get the metaHistory for the new metaId
            this.props.fetchLastPlayedSongsIfNeeded();
        } else if (prevProps.time !== this.props.time) {
            // add the new track to the lastPlayedSongs
            this.props.addLastPlayedSongIfNeeded();
        }
    }

    render() {
        return (
            <div className="aovivo-lastPlayedSongs">
                <header>
                    <h2>As últimas músicas tocadas</h2>
                    <p className="subtitle">Acompanhe as canções que tocaram na última hora</p>
                </header>
                {this.props.lastPlayedSongs.length > 0 ?
                    <LastPlayedSongsSlider
                        songs={this.props.lastPlayedSongs}
                        showSpotModal={this.props.showSpotModal}
                    /> :
                    <Placeholder width="100%" minHeight="255px" />}
            </div>
        );
    }
}

LastPlayedSongs.propTypes = exact({
    fetchLastPlayedSongsIfNeeded: PropTypes.func.isRequired,
    addLastPlayedSongIfNeeded: PropTypes.func.isRequired,
    showSpotModal: PropTypes.func.isRequired,
    lastPlayedSongs: PropTypes.array.isRequired,
    currentMetaId: PropTypes.string.isRequired,
    time: PropTypes.string,
});


export default LastPlayedSongs;
